import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';

import { SlideIn, SubmitButton } from 'components';

import {
  InsuredItem,
  SingleSelectStepProps,
  YesNoAnswer,
  YES_NO_OPTIONS,
} from 'scenes/common/types';
import {
  SegmentedControlQuestion,
  SelectQuestion,
} from 'scenes/common/components/Questions';

const PROPERTY_BUILT_YEAR = 'propertyBuiltYear';
const CERTIFICATE_OF_OCCUPANCY = 'certificateOfOccupancy';

export const HELP_TEXT =
  "Don't worry if you are not exactly sure, your best estimate will be fine.";

const PropertyBuiltYearStep: FunctionComponent<
  Pick<SingleSelectStepProps, 'defaultStateValue' | 'onNext' | 'options'> & {
    certificateOfOccupancyAnswerRequired: (buildYear: string) => boolean;
    certificateOfOccupancyDefaultValue: YesNoAnswer;
    insuredItem: InsuredItem;
  }
> = ({
  defaultStateValue,
  onNext,
  options,
  certificateOfOccupancyAnswerRequired,
  certificateOfOccupancyDefaultValue,
  insuredItem,
}) => {
  const {
    formState: { isValid },
    handleSubmit,
    control,
    errors,
    watch,
  } = useForm({
    mode: 'onChange',
  });

  const watchedBuildYear = watch(PROPERTY_BUILT_YEAR, defaultStateValue);

  const CERTIFICATE_OF_OCCUPANCY_QUESTION = `Has the ${insuredItem} been issued with a Certificate of Occupancy?`;

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SelectQuestion
        question={`When was the ${insuredItem} built?`}
        stateKey={PROPERTY_BUILT_YEAR}
        options={options}
        helpText={HELP_TEXT}
        defaultValue={defaultStateValue}
        isLoading={false}
        control={control}
        ariaRequired
      />
      {certificateOfOccupancyAnswerRequired(watchedBuildYear) && (
        <SlideIn>
          <SegmentedControlQuestion
            question={CERTIFICATE_OF_OCCUPANCY_QUESTION}
            stateKey={CERTIFICATE_OF_OCCUPANCY}
            options={YES_NO_OPTIONS}
            defaultValue={certificateOfOccupancyDefaultValue}
            control={control}
            errors={errors}
          />
        </SlideIn>
      )}
      <SubmitButton enabled={isValid}>Next</SubmitButton>
    </form>
  );
};

export default PropertyBuiltYearStep;
